"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1629],{

/***/ 55030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1216);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(77445);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86314);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17499);
/* harmony import */ var components_organisms_FeedbackGleads__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61089);
/* harmony import */ var components_organisms_PostSlider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82202);
/* harmony import */ var components_organisms_ServiceCatalog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49754);
/* harmony import */ var components_organisms_GleadsSubjects__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54578);
/* harmony import */ var components_molecules_ServiceCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73310);
/* harmony import */ var _BannerTrangchu__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65573);
/* harmony import */ var node_modules_next_dynamic__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5152);
/* harmony import */ var node_modules_next_dynamic__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(node_modules_next_dynamic__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _react_icons_all_files_ai_AiOutlineRise__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93336);
/* harmony import */ var _react_icons_all_files_fi_FiMapPin__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(46159);
/* harmony import */ var _react_icons_all_files_fi_FiBarChart__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18521);
/* harmony import */ var _react_icons_all_files_bi_BiBroadcast__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44271);
/* harmony import */ var _react_icons_all_files_bi_BiNetworkChart__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(21488);
/* harmony import */ var _react_icons_all_files_bi_BiBriefcaseAlt2__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(41287);
/* harmony import */ var _react_icons_all_files_bi_BiBuildingHouse__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(56276);
/* harmony import */ var _react_icons_all_files_bi_BiBuilding__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29601);

/*** Vendors ***/ 

/*** components ***/ 





// import CountUp from "components/templates/trang-chu/CountUp";











var CountUp = node_modules_next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(function() {
    return __webpack_require__.e(/* import() */ 5193).then(__webpack_require__.bind(__webpack_require__, 65193));
}, {
    ssr: false
});
// const Feedback = dynamic(() => import("components/organisms/FeedbackGleads"), {
//   ssr: false,
// });
/** data */ var campaigns = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_ai_AiOutlineRise__WEBPACK_IMPORTED_MODULE_11__/* .AiOutlineRise */ .V, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "T\u0103ng tr\u01B0\u1EDFng traffic",
        description: "L\u01B0u l\u01B0\u1EE3ng truy c\u1EADp th\u1EF1c (real traffic) \u0111\u01B0\u1EE3c xem l\xe0 n\u1EC1n t\u1EA3ng ph\xe1t tri\u1EC3n c\u1EE7a m\u1ECDi chi\u1EBFn d\u1ECBch ti\u1EBFp th\u1ECB s\u1ED1. Gleads cung c\u1EA5p c\xe1c gi\u1EA3i ph\xe1p t\u0103ng tr\u01B0\u1EDFng l\u01B0u l\u01B0\u1EE3ng t\u1EF1 nhi\xean v\xe0 t\u1ED1i \u01B0u organic traffic gi\xfap \u0111\u1EA3m b\u1EA3o website c\u1EE7a doanh nghi\u1EC7p \u0111\u1EA1t hi\u1EC7u su\u1EA5t hi\u1EC7u su\u1EA5t t\u1ED1i \u01B0u nh\u1EA5t, t\u1EEB \u0111\xf3 t\u0103ng kh\u1EA3 n\u0103ng c\u1EA1nh tranh gi\xfap doanh nghi\u1EC7p l\xe0m ch\u1EE7 ng\xe0nh h\xe0ng."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_bi_BiBroadcast__WEBPACK_IMPORTED_MODULE_12__/* .BiBroadcast */ .j, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "T\u0103ng \u0111\u1ED9 ph\u1EE7 s\xf3ng th\u01B0\u01A1ng hi\u1EC7u",
        description: "Ph\xe1t tri\u1EC3n nh\u1EADn di\u1EC7n th\u01B0\u01A1ng hi\u1EC7u mang l\u1EA1i s\u1EE9c m\u1EA1nh phi th\u01B0\u1EDDng cho m\u1ECDi doanh nghi\u1EC7p. Website leo top 1 v\xe0 duy tr\xec \u1ED5n \u0111\u1ECBnh tr\xean s\xe2n ch\u01A1i Google, doanh nghi\u1EC7p g\u1EA7n nh\u01B0 c\xf3 th\u1EC3 kh\u1ED1ng ch\u1EBF c\u1EA3 cu\u1ED9c ch\u01A1i trong th\u1EDDi gian ng\u1EAFn nh\u01B0ng r\u1EA5t \u0111\u1EAFt gi\xe1, khi s\u1ED1 l\u01B0\u1EE3ng ng\u01B0\u1EDDi d\xf9ng truy c\u1EADp t\u0103ng l\xean, ch\u1EC9 s\u1ED1 nh\u1EADn di\u1EC7n th\u01B0\u01A1ng hi\u1EC7u s\u1EBD t\u0103ng theo."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiBarChart__WEBPACK_IMPORTED_MODULE_13__/* .FiBarChart */ .D, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "C\u1EA3i thi\u1EC7n Return of Investment (ROI)",
        description: "Ch\u1EC9 s\u1ED1 ROI c\xe0ng cao l\xe0 t\xedn hi\u1EC7u \u0111\xe1ng m\u1EEBng cho m\u1ED9t m\xf4 h\xecnh kinh doanh hi\u1EC7u qu\u1EA3. H\xe0ng ng\xe0n kh\xe1ch h\xe0ng Gleads \u0111\xe3 t\u1ED1i \u01B0u doanh thu b\xe1n h\xe0ng v\xe0 ch\u1ED1t \u0111\u01A1n th\xe0nh c\xf4ng th\xf4ng qua c\xe1c d\u1EF1 \xe1n landing page optimzation, SEO t\u1ED5ng th\u1EC3, content marketing, Facebook ads. H\xe3y \u0111\u1EC3 Gleads gi\xfap doanh nghi\u1EC7p t\u0103ng tr\u01B0\u1EDFng ROI!"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_bi_BiNetworkChart__WEBPACK_IMPORTED_MODULE_14__/* .BiNetworkChart */ .D, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "K\u1EBFt n\u1ED1i kh\xe1ch h\xe0ng ti\u1EC1m n\u0103ng, t\u1ED1i \u01B0u l\u1EE3i nhu\u1EADn",
        description: "D\u1ECBch v\u1EE5 SEO content chuy\xean bi\u1EC7t gi\xfap x\xe2y d\u1EF1ng c\xe1c n\u1EC1n t\u1EA3ng li\xean k\u1EBFt cho website, n\u1ED9i dung ph\xf9 h\u1EE3p ng\u01B0\u1EDDi d\xf9ng \u1EDF t\u1EEBng giai \u0111o\u1EA1n, thi\u1EBFt k\u1EBF chuy\xean nghi\u1EC7p gi\xfap t\u1ED1i \u01B0u tr\u1EA3i nghi\u1EC7m kh\xe1ch h\xe0ng, chi\u1EBFn d\u1ECBch qu\u1EA3ng c\xe1o t\u1ED1i \u01B0u l\u1EE3i nhu\u1EADn nhanh ch\xf3ng v\xe0 ti\u1EBFp c\u1EADn l\u01B0\u1EE3ng l\u1EDBn kh\xe1ch h\xe0ng ti\u1EC1m n\u0103ng."
    }, 
];
var subjects = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_bi_BiBriefcaseAlt2__WEBPACK_IMPORTED_MODULE_15__/* .BiBriefcaseAlt2 */ .g, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "Kh\u1EDFi nghi\u1EC7p Startups"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_bi_BiBuildingHouse__WEBPACK_IMPORTED_MODULE_16__/* .BiBuildingHouse */ .O, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "Doanh nghi\u1EC7p v\u1EEBa v\xe0 nh\u1ECF (SMEs)"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_bi_BiBuilding__WEBPACK_IMPORTED_MODULE_17__/* .BiBuilding */ .n, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "Doanh nghi\u1EC7p l\u1EDBn"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiMapPin__WEBPACK_IMPORTED_MODULE_18__/* .FiMapPin */ .i, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "C\xe1c chi nh\xe1nh ho\u1EB7c th\u01B0\u01A1ng hi\u1EC7u con"
    }, 
];
/** ========== */ function Home(param) {
    var dataStatic = param.dataStatic, dataPost = param.dataPost;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BannerTrangchu__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "section-blue pb-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container mb-10 lg:mb-20",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            as: "h2",
                            othersClass: "text-left lg:text-center mb-6 lg:mb-10",
                            title: {
                                content: "\u0110\u1ED9t ph\xe1 doanh thu <br/> trong th\u1EDDi \u0111\u1EA1i c\xf4ng ngh\u1EC7 s\u1ED1",
                                default_word_color: "text-gleads-pink-600",
                                highlight_word_list: [
                                    "trong th\u1EDDi \u0111\u1EA1i c\xf4ng ngh\u1EC7 s\u1ED1"
                                ],
                                highlight_word_colors: "text-gleads-oxfordBlue-700"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                "M\u1EE5c ti\xeau c\u1EE7a doanh nghi\u1EC7p ch\u1EC9 c\xf3 m\u1ED9t v\xe0 s\u1EE9 m\u1EC7nh c\u1EE7a ch\xfang t\xf4i l\xe0 \u0111\u01B0a kh\xe1ch h\xe0ng l\xean top 1. Gleads chuy\xean cung c\u1EA5p c\xe1c gi\u1EA3i ph\xe1p marketing t\u1ED5ng th\u1EC3 t\xedch h\u1EE3p ph\u01B0\u01A1ng th\u1EE9c qu\u1EA3n l\xfd d\u1EF1 \xe1n c\xf4ng ngh\u1EC7 hi\u1EC7n \u0111\u1EA1i, ph\xf9 h\u1EE3p cho m\u1ECDi doanh nghi\u1EC7p thu\u1ED9c \u0111a l\u0129nh v\u1EF1c v\xe0 ng\xe0nh ngh\u1EC1.",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mb-0",
                            children: "Gleads \u0111\u1ED3ng h\xe0nh c\xf9ng t\u1EA5t c\u1EA3 c\xe1c doanh nghi\u1EC7p \u0111ang c\u1EA7n t\xecm \u0111\u1ED1i t\xe1c c\xf3 \u201Ct\xe2m\u201D v\xe0 \u201Ct\u1EA7m\u201D trong qu\xe1 tr\xecnh chuy\u1EC3n \u0111\u1ED5i s\u1ED1 \u1EE9ng d\u1EE5ng ti\u1EBFp th\u1ECB v\xe0 qu\u1EA3ng b\xe1 d\u1ECBch v\u1EE5. Gleads th\u1EA5u hi\u1EC3u c\xe1c v\u1EA5n \u0111\u1EC1 nan gi\u1EA3i c\u1EE7a kh\xe1ch h\xe0ng, ch\xfang t\xf4i h\u01B0\u1EDBng t\u1EDBi c\xe1c d\u1ECBch v\u1EE5 v\u1EDBi chi ph\xed h\u1EE3p l\xed, l\u1EE3i nhu\u1EADn t\u1ED1i \u01B0u, ph\xe1t tri\u1EC3n v\u1EEFng b\u1EC1n v\xe0 n\xe2ng cao ch\u1EA5t l\u01B0\u1EE3ng trong m\u1ED7i d\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng s\u1EED d\u1EE5ng."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "section-blue pt-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-6 lg:mb-15",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    as: "h2",
                                    othersClass: "text-left lg:text-center mb-6 lg:mb-10",
                                    title: {
                                        content: "Gleads cung c\u1EA5p \u0111a d\u1EA1ng d\u1ECBch v\u1EE5 <br/> marketing & truy\u1EC1n th\xf4ng s\u1ED1",
                                        default_word_color: "text-gleads-oxfordBlue-700",
                                        highlight_word_list: [
                                            "marketing & truy\u1EC1n th\xf4ng s\u1ED1"
                                        ],
                                        highlight_word_colors: "text-gleads-pink-600"
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            "Gleads l\xean chi\u1EBFn l\u01B0\u1EE3c, th\u1EF1c hi\u1EC7n, t\u1ED1i \u01B0u v\xe0 b\xe1o c\xe1o \u0111\u1EA7y \u0111\u1EE7 cho kh\xe1ch h\xe0ng. Ch\xfang t\xf4i cung c\u1EA5p \u0111a d\u1EA1ng c\xe1c d\u1ECBch v\u1EE5 ti\u1EBFp th\u1ECB, truy\u1EC1n th\xf4ng s\u1ED1 b\u1EB1ng c\xe1c thu\u1EADt to\xe1n v\xe0 c\xf4ng ngh\u1EC7 m\u1EDBi nh\u1EA5t. Ph\u1EA1m vi d\u1ECBch v\u1EE5 Gleads t\u1EADp trung v\xe0o c\xe1c gi\u1EA3i ph\xe1p SEO, SEM, PPC advertising, communication, web design & development, outsourced marketing team cho doanh nghi\u1EC7p Vi\u1EC7t. ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "C\u1EB7p \u0111\xf4i d\u1ECBch v\u1EE5 c\u01A1 b\u1EA3n cho m\u1ED7i doanh nghi\u1EC7p kh\xf4ng th\u1EC3 b\u1ECF l\u1EE1 t\u1EA1i Gleads: SEO & Google Ads c\xf3 th\u1EC3 gi\xfap kh\xe1ch h\xe0ng d\u1EC5 d\xe0ng leo top t\u1EEB kh\xf3a, t\u0103ng l\u01B0\u1EE3t hi\u1EC3n th\u1ECB tr\xean c\xe1c c\xf4ng c\u1EE5 t\xecm ki\u1EBFm Google, Bing, Yahoo..., ti\u1EBFp c\u1EADn kh\xe1ch h\xe0ng ti\u1EC1m n\u0103ng v\xe0 t\u1ED1i \u01B0u t\u1EC9 l\u1EC7 chuy\u1EC3n \u0111\u1ED5i (conversion rate).",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "Kh\xe1ch h\xe0ng c\u1EA7n m\u1ED9t website di\u1EC7n m\u1EA1o n\u1ED5i b\u1EADt, thi\u1EBFt k\u1EBF \u1EA5n t\u01B0\u1EE3ng, t\u1ED1i \u01B0u tr\u1EA3i nghi\u1EC7m ng\u01B0\u1EDDi d\xf9ng \u0111\u1EC3 chi\u1EBFm \u01B0u th\u1EBF trong th\u1ECB th\u01B0\u1EDDng c\xf3 nhi\u1EC1u \u0111\u1ED1i th\u1EE7 c\u1EA1nh tranh. Gleads cung c\u1EA5p d\u1ECBch v\u1EE5 thi\u1EBFt k\u1EBF nh\u1EADn di\u1EC7n th\u01B0\u01A1ng hi\u1EC7u gi\xfap doanh nghi\u1EC7p chinh ph\u1EE5c th\u1ECB gi\xe1c ng\u01B0\u1EDDi d\xf9ng, d\u1EC5 d\xe0ng t\u01B0\u01A1ng t\xe1c v\u1EDBi kh\xe1ch h\xe0ng, t\u1ED1i \u01B0u h\xf3a doanh thu.",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "H\xe3y kh\xe1m ph\xe1 c\xe1c d\u1ECBch v\u1EE5 c\u1EE7a Gleads!"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-auto lg:col-10",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_organisms_ServiceCatalog__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    services: dataStatic === null || dataStatic === void 0 ? void 0 : dataStatic.services
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "relative bg-gleads-oxfordBlue-800 pt-15 pb-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container relative z-10",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "lg:col-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        as: "h2",
                                        othersClass: "text-left mb-6 lg:mb-10",
                                        title: {
                                            content: "Chi\u1EBFn d\u1ECBch Gleads \u0111\xe3 v\xe0 \u0111ang l\xe0m cho kh\xe1ch h\xe0ng",
                                            default_word_color: "text-gleads-pink-600",
                                            highlight_word_list: [
                                                "\u0111\xe3 v\xe0 \u0111ang l\xe0m cho kh\xe1ch h\xe0ng"
                                            ],
                                            highlight_word_colors: "text-white"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "lg:col-8",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "row",
                                        children: campaigns.map(function(campaign, idx) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_molecules_ServiceCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                data: campaign,
                                                className: "mb-10 lg:col-6",
                                                inner: {
                                                    className: "px-6 py-8",
                                                    iconStyles: "rounded-full bg-gleads-buttonBlue-100 p-3",
                                                    titleStyles: "text-gleads-pink-700",
                                                    descriptionStyles: ""
                                                }
                                            }, "compaign-".concat(idx));
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        width: 1920,
                        height: 916,
                        alt: "wabe-bottom",
                        src: "/assets/images/home/background-design-home.png",
                        className: "h-full w-full object-cover",
                        wrapper: {
                            className: "absolute z-0 top-0 w-full h-full z-0 hidden lg:block"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "section-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CountUp, {
                            data: dataStatic.countUp
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-gleads-oxfordBlue-100 pt-15",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            as: "h2",
                            othersClass: "lg:text-center mb-6 xl:mb-18",
                            title: {
                                content: "D\u1ECBch v\u1EE5 c\u1EE7a Gleads ph\xf9 h\u1EE3p v\u1EDBi m\u1ECDi \u0111\u1ED1i t\u01B0\u1EE3ng",
                                default_word_color: "text-gleads-oxfordBlue-700",
                                highlight_word_list: [
                                    "m\u1ECDi \u0111\u1ED1i t\u01B0\u1EE3ng"
                                ],
                                highlight_word_colors: "text-gleads-pink-600"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_organisms_GleadsSubjects__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    data: subjects,
                                    colClassName: "lg:col-3 lg:pt-3 lg:mb-15 "
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative lg:col-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        src: "/assets/images/home/subjects.png",
                                        width: 638,
                                        height: 600,
                                        className: "h-full w-full",
                                        wrapper: {
                                            className: (_Index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().subjectsImage)
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "section-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            as: "h2",
                            othersClass: "lg:text-center mb-6 lg:mb-9",
                            title: {
                                content: "Nh\u1EADn x\xe9t c\u1EE7a kh\xe1ch h\xe0ng",
                                default_word_color: "text-gleads-oxfordBlue-700"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_organisms_FeedbackGleads__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            data: dataStatic === null || dataStatic === void 0 ? void 0 : dataStatic.feedbacks
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "section-blue-post",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            title: {
                                content: "B\xe0i vi\u1EBFt li\xean quan"
                            },
                            othersClass: "lg:text-center mb-2 lg:mb-0"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12 px-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_organisms_PostSlider__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    posts: dataPost
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 9782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1216);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(74900);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _Banner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78942);
/* harmony import */ var mobile_components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7761);
/* harmony import */ var mobile_components_organisms_Feedback__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19891);
/* harmony import */ var mobile_components_organisms_PostSlider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72302);
/* harmony import */ var mobile_components_molecules_ServiceCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62141);
/* harmony import */ var mobile_components_organisms_ServiceCatalog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52427);
/* harmony import */ var mobile_components_organisms_GleadsSubjects__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96490);
/* harmony import */ var _react_icons_all_files_ai_AiOutlineRise__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93336);
/* harmony import */ var _react_icons_all_files_fi_FiMapPin__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(46159);
/* harmony import */ var _react_icons_all_files_fi_FiBarChart__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18521);
/* harmony import */ var _react_icons_all_files_bi_BiBroadcast__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44271);
/* harmony import */ var _react_icons_all_files_bi_BiNetworkChart__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(21488);
/* harmony import */ var _react_icons_all_files_bi_BiBriefcaseAlt2__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(41287);
/* harmony import */ var _react_icons_all_files_bi_BiBuildingHouse__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(56276);
/* harmony import */ var _react_icons_all_files_bi_BiBuilding__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29601);

/*** Vendors ***/ 



/*** components ***/ 














var CountUp = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 6417).then(__webpack_require__.bind(__webpack_require__, 46417));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46417)
            ];
        }
    },
    ssr: false
});
/** data */ var campaigns = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_ai_AiOutlineRise__WEBPACK_IMPORTED_MODULE_11__/* .AiOutlineRise */ .V, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "T\u0103ng tr\u01B0\u1EDFng traffic",
        description: "L\u01B0u l\u01B0\u1EE3ng truy c\u1EADp th\u1EF1c (real traffic) \u0111\u01B0\u1EE3c xem l\xe0 n\u1EC1n t\u1EA3ng ph\xe1t tri\u1EC3n c\u1EE7a m\u1ECDi chi\u1EBFn d\u1ECBch ti\u1EBFp th\u1ECB s\u1ED1. Gleads cung c\u1EA5p c\xe1c gi\u1EA3i ph\xe1p t\u0103ng tr\u01B0\u1EDFng l\u01B0u l\u01B0\u1EE3ng t\u1EF1 nhi\xean v\xe0 t\u1ED1i \u01B0u organic traffic gi\xfap \u0111\u1EA3m b\u1EA3o website c\u1EE7a doanh nghi\u1EC7p \u0111\u1EA1t hi\u1EC7u su\u1EA5t hi\u1EC7u su\u1EA5t t\u1ED1i \u01B0u nh\u1EA5t, t\u1EEB \u0111\xf3 t\u0103ng kh\u1EA3 n\u0103ng c\u1EA1nh tranh gi\xfap doanh nghi\u1EC7p l\xe0m ch\u1EE7 ng\xe0nh h\xe0ng."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_bi_BiBroadcast__WEBPACK_IMPORTED_MODULE_12__/* .BiBroadcast */ .j, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "T\u0103ng \u0111\u1ED9 ph\u1EE7 s\xf3ng th\u01B0\u01A1ng hi\u1EC7u",
        description: "Ph\xe1t tri\u1EC3n nh\u1EADn di\u1EC7n th\u01B0\u01A1ng hi\u1EC7u mang l\u1EA1i s\u1EE9c m\u1EA1nh phi th\u01B0\u1EDDng cho m\u1ECDi doanh nghi\u1EC7p. Website leo top 1 v\xe0 duy tr\xec \u1ED5n \u0111\u1ECBnh tr\xean s\xe2n ch\u01A1i Google, doanh nghi\u1EC7p g\u1EA7n nh\u01B0 c\xf3 th\u1EC3 kh\u1ED1ng ch\u1EBF c\u1EA3 cu\u1ED9c ch\u01A1i trong th\u1EDDi gian ng\u1EAFn nh\u01B0ng r\u1EA5t \u0111\u1EAFt gi\xe1, khi s\u1ED1 l\u01B0\u1EE3ng ng\u01B0\u1EDDi d\xf9ng truy c\u1EADp t\u0103ng l\xean, ch\u1EC9 s\u1ED1 nh\u1EADn di\u1EC7n th\u01B0\u01A1ng hi\u1EC7u s\u1EBD t\u0103ng theo."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiBarChart__WEBPACK_IMPORTED_MODULE_13__/* .FiBarChart */ .D, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "C\u1EA3i thi\u1EC7n Return of Investment (ROI)",
        description: "Ch\u1EC9 s\u1ED1 ROI c\xe0ng cao l\xe0 t\xedn hi\u1EC7u \u0111\xe1ng m\u1EEBng cho m\u1ED9t m\xf4 h\xecnh kinh doanh hi\u1EC7u qu\u1EA3. H\xe0ng ng\xe0n kh\xe1ch h\xe0ng Gleads \u0111\xe3 t\u1ED1i \u01B0u doanh thu b\xe1n h\xe0ng v\xe0 ch\u1ED1t \u0111\u01A1n th\xe0nh c\xf4ng th\xf4ng qua c\xe1c d\u1EF1 \xe1n landing page optimzation, SEO t\u1ED5ng th\u1EC3, content marketing, Facebook ads. H\xe3y \u0111\u1EC3 Gleads gi\xfap doanh nghi\u1EC7p t\u0103ng tr\u01B0\u1EDFng ROI!"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_bi_BiNetworkChart__WEBPACK_IMPORTED_MODULE_14__/* .BiNetworkChart */ .D, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "K\u1EBFt n\u1ED1i kh\xe1ch h\xe0ng ti\u1EC1m n\u0103ng, t\u1ED1i \u01B0u l\u1EE3i nhu\u1EADn",
        description: "D\u1ECBch v\u1EE5 SEO content chuy\xean bi\u1EC7t gi\xfap x\xe2y d\u1EF1ng c\xe1c n\u1EC1n t\u1EA3ng li\xean k\u1EBFt cho website, n\u1ED9i dung ph\xf9 h\u1EE3p ng\u01B0\u1EDDi d\xf9ng \u1EDF t\u1EEBng giai \u0111o\u1EA1n, thi\u1EBFt k\u1EBF chuy\xean nghi\u1EC7p gi\xfap t\u1ED1i \u01B0u tr\u1EA3i nghi\u1EC7m kh\xe1ch h\xe0ng, chi\u1EBFn d\u1ECBch qu\u1EA3ng c\xe1o t\u1ED1i \u01B0u l\u1EE3i nhu\u1EADn nhanh ch\xf3ng v\xe0 ti\u1EBFp c\u1EADn l\u01B0\u1EE3ng l\u1EDBn kh\xe1ch h\xe0ng ti\u1EC1m n\u0103ng."
    }, 
];
var subjects = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_bi_BiBriefcaseAlt2__WEBPACK_IMPORTED_MODULE_15__/* .BiBriefcaseAlt2 */ .g, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "Kh\u1EDFi nghi\u1EC7p Startups"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_bi_BiBuildingHouse__WEBPACK_IMPORTED_MODULE_16__/* .BiBuildingHouse */ .O, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "Doanh nghi\u1EC7p v\u1EEBa v\xe0 nh\u1ECF (SMEs)"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_bi_BiBuilding__WEBPACK_IMPORTED_MODULE_17__/* .BiBuilding */ .n, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "Doanh nghi\u1EC7p l\u1EDBn"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiMapPin__WEBPACK_IMPORTED_MODULE_18__/* .FiMapPin */ .i, {
            size: 40,
            color: "#2EAFEF"
        }),
        title: "C\xe1c chi nh\xe1nh ho\u1EB7c th\u01B0\u01A1ng hi\u1EC7u con"
    }, 
];
/** ========== */ function Home(param) {
    var dataStatic = param.dataStatic, dataPost = param.dataPost;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Banner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "py-10 pb-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container mb-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mobile_components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            as: "h2",
                            othersClass: "text-left mb-6",
                            title: {
                                content: "\u0110\u1ED9t ph\xe1 doanh thu <br/> trong th\u1EDDi \u0111\u1EA1i c\xf4ng ngh\u1EC7 s\u1ED1",
                                default_word_color: "text-gleads-pink-600",
                                highlight_word_list: [
                                    "trong th\u1EDDi \u0111\u1EA1i c\xf4ng ngh\u1EC7 s\u1ED1"
                                ],
                                highlight_word_colors: "text-gleads-oxfordBlue-700"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                "M\u1EE5c ti\xeau c\u1EE7a doanh nghi\u1EC7p ch\u1EC9 c\xf3 m\u1ED9t v\xe0 s\u1EE9 m\u1EC7nh c\u1EE7a ch\xfang t\xf4i l\xe0 \u0111\u01B0a kh\xe1ch h\xe0ng l\xean top 1. Gleads chuy\xean cung c\u1EA5p c\xe1c gi\u1EA3i ph\xe1p marketing t\u1ED5ng th\u1EC3 t\xedch h\u1EE3p ph\u01B0\u01A1ng th\u1EE9c qu\u1EA3n l\xfd d\u1EF1 \xe1n c\xf4ng ngh\u1EC7 hi\u1EC7n \u0111\u1EA1i, ph\xf9 h\u1EE3p cho m\u1ECDi doanh nghi\u1EC7p thu\u1ED9c \u0111a l\u0129nh v\u1EF1c v\xe0 ng\xe0nh ngh\u1EC1 mobile.",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mb-0",
                            children: "Gleads \u0111\u1ED3ng h\xe0nh c\xf9ng t\u1EA5t c\u1EA3 c\xe1c doanh nghi\u1EC7p \u0111ang c\u1EA7n t\xecm \u0111\u1ED1i t\xe1c c\xf3 \u201Ct\xe2m\u201D v\xe0 \u201Ct\u1EA7m\u201D trong qu\xe1 tr\xecnh chuy\u1EC3n \u0111\u1ED5i s\u1ED1 \u1EE9ng d\u1EE5ng ti\u1EBFp th\u1ECB v\xe0 qu\u1EA3ng b\xe1 d\u1ECBch v\u1EE5. Gleads th\u1EA5u hi\u1EC3u c\xe1c v\u1EA5n \u0111\u1EC1 nan gi\u1EA3i c\u1EE7a kh\xe1ch h\xe0ng, ch\xfang t\xf4i h\u01B0\u1EDBng t\u1EDBi c\xe1c d\u1ECBch v\u1EE5 v\u1EDBi chi ph\xed h\u1EE3p l\xed, l\u1EE3i nhu\u1EADn t\u1ED1i \u01B0u, ph\xe1t tri\u1EC3n v\u1EEFng b\u1EC1n v\xe0 n\xe2ng cao ch\u1EA5t l\u01B0\u1EE3ng trong m\u1ED7i d\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng s\u1EED d\u1EE5ng."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "py-10 pt-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mobile_components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    as: "h2",
                                    othersClass: "text-left mb-6",
                                    title: {
                                        content: "Gleads cung c\u1EA5p \u0111a d\u1EA1ng d\u1ECBch v\u1EE5 <br/> marketing & truy\u1EC1n th\xf4ng s\u1ED1",
                                        default_word_color: "text-gleads-oxfordBlue-700",
                                        highlight_word_list: [
                                            "marketing & truy\u1EC1n th\xf4ng s\u1ED1"
                                        ],
                                        highlight_word_colors: "text-gleads-pink-600"
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            "Gleads l\xean chi\u1EBFn l\u01B0\u1EE3c, th\u1EF1c hi\u1EC7n, t\u1ED1i \u01B0u v\xe0 b\xe1o c\xe1o \u0111\u1EA7y \u0111\u1EE7 cho kh\xe1ch h\xe0ng. Ch\xfang t\xf4i cung c\u1EA5p \u0111a d\u1EA1ng c\xe1c d\u1ECBch v\u1EE5 ti\u1EBFp th\u1ECB, truy\u1EC1n th\xf4ng s\u1ED1 b\u1EB1ng c\xe1c thu\u1EADt to\xe1n v\xe0 c\xf4ng ngh\u1EC7 m\u1EDBi nh\u1EA5t. Ph\u1EA1m vi d\u1ECBch v\u1EE5 Gleads t\u1EADp trung v\xe0o c\xe1c gi\u1EA3i ph\xe1p SEO, SEM, PPC advertising, communication, web design & development, outsourced marketing team cho doanh nghi\u1EC7p Vi\u1EC7t. ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "C\u1EB7p \u0111\xf4i d\u1ECBch v\u1EE5 c\u01A1 b\u1EA3n cho m\u1ED7i doanh nghi\u1EC7p kh\xf4ng th\u1EC3 b\u1ECF l\u1EE1 t\u1EA1i Gleads: SEO & Google Ads c\xf3 th\u1EC3 gi\xfap kh\xe1ch h\xe0ng d\u1EC5 d\xe0ng leo top t\u1EEB kh\xf3a, t\u0103ng l\u01B0\u1EE3t hi\u1EC3n th\u1ECB tr\xean c\xe1c c\xf4ng c\u1EE5 t\xecm ki\u1EBFm Google, Bing, Yahoo..., ti\u1EBFp c\u1EADn kh\xe1ch h\xe0ng ti\u1EC1m n\u0103ng v\xe0 t\u1ED1i \u01B0u t\u1EC9 l\u1EC7 chuy\u1EC3n \u0111\u1ED5i (conversion rate).",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "Kh\xe1ch h\xe0ng c\u1EA7n m\u1ED9t website di\u1EC7n m\u1EA1o n\u1ED5i b\u1EADt, thi\u1EBFt k\u1EBF \u1EA5n t\u01B0\u1EE3ng, t\u1ED1i \u01B0u tr\u1EA3i nghi\u1EC7m ng\u01B0\u1EDDi d\xf9ng \u0111\u1EC3 chi\u1EBFm \u01B0u th\u1EBF trong th\u1ECB th\u01B0\u1EDDng c\xf3 nhi\u1EC1u \u0111\u1ED1i th\u1EE7 c\u1EA1nh tranh. Gleads cung c\u1EA5p d\u1ECBch v\u1EE5 thi\u1EBFt k\u1EBF nh\u1EADn di\u1EC7n th\u01B0\u01A1ng hi\u1EC7u gi\xfap doanh nghi\u1EC7p chinh ph\u1EE5c th\u1ECB gi\xe1c ng\u01B0\u1EDDi d\xf9ng, d\u1EC5 d\xe0ng t\u01B0\u01A1ng t\xe1c v\u1EDBi kh\xe1ch h\xe0ng, t\u1ED1i \u01B0u h\xf3a doanh thu.",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            "H\xe3y kh\xe1m ph\xe1 c\xe1c d\u1ECBch v\u1EE5 c\u1EE7a Gleads!"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mobile_components_organisms_ServiceCatalog__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    services: dataStatic === null || dataStatic === void 0 ? void 0 : dataStatic.services
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "relative bg-gleads-oxfordBlue-800 pt-15 pb-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container relative z-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mobile_components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    as: "h2",
                                    othersClass: "text-left mb-6",
                                    title: {
                                        content: "Chi\u1EBFn d\u1ECBch Gleads \u0111\xe3 v\xe0 \u0111ang l\xe0m cho kh\xe1ch h\xe0ng",
                                        default_word_color: "text-gleads-pink-600",
                                        highlight_word_list: [
                                            "\u0111\xe3 v\xe0 \u0111ang l\xe0m cho kh\xe1ch h\xe0ng"
                                        ],
                                        highlight_word_colors: "text-white"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row",
                                    children: campaigns.map(function(campaign, idx) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mobile_components_molecules_ServiceCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            data: campaign,
                                            className: "mb-10",
                                            inner: {
                                                className: "px-6 py-8",
                                                iconStyles: "rounded-full bg-gleads-buttonBlue-100 p-3",
                                                titleStyles: "text-gleads-pink-700",
                                                descriptionStyles: ""
                                            }
                                        }, "compaign-".concat(idx));
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-white py-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CountUp, {
                            data: dataStatic.countUp
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-gleads-oxfordBlue-100 pt-15",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mobile_components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            as: "h2",
                            othersClass: "mb-6",
                            title: {
                                content: "D\u1ECBch v\u1EE5 c\u1EE7a Gleads ph\xf9 h\u1EE3p v\u1EDBi m\u1ECDi \u0111\u1ED1i t\u01B0\u1EE3ng",
                                default_word_color: "text-gleads-oxfordBlue-700",
                                highlight_word_list: [
                                    "m\u1ECDi \u0111\u1ED1i t\u01B0\u1EE3ng"
                                ],
                                highlight_word_colors: "text-gleads-pink-600"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mobile_components_organisms_GleadsSubjects__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    data: subjects
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_Index_module_scss__WEBPACK_IMPORTED_MODULE_19___default().subjectsImage),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            src: "/assets/images/home/subjects.png",
                                            alt: "subjects",
                                            width: 638,
                                            height: 600,
                                            unoptimized: true,
                                            className: "h-full w-full"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-white py-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mobile_components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            as: "h2",
                            othersClass: "mb-6",
                            title: {
                                content: "Nh\u1EADn x\xe9t c\u1EE7a kh\xe1ch h\xe0ng",
                                default_word_color: "text-gleads-oxfordBlue-700"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mobile_components_organisms_Feedback__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            data: dataStatic === null || dataStatic === void 0 ? void 0 : dataStatic.feedbacks
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "overflow-hidden py-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mobile_components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            title: {
                                content: "B\xe0i vi\u1EBFt li\xean quan"
                            },
                            othersClass: "mb-2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12 px-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mobile_components_organisms_PostSlider__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    posts: dataPost
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/***/ })

}]);